/** OpenAI Responses API input_file constraints used by AI Chat. */
export var AI_CHAT_SUPPORTED_FILE_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png', '.webp', '.gif', '.xla', '.xlb', '.xlc', '.xlm', '.xls', '.xlsx', '.xlt', '.xlw', '.csv', '.tsv', '.iif', '.doc', '.docx', '.dot', '.odt', '.rtf', '.pages', '.pot', '.ppa', '.pps', '.ppt', '.pptx', '.pwz', '.wiz', '.key', '.keynote', '.asm', '.bat', '.c', '.cc', '.conf', '.cpp', '.css', '.cxx', '.def', '.dic', '.eml', '.h', '.hh', '.htm', '.html', '.ics', '.ifb', '.in', '.js', '.json', '.ksh', '.list', '.log', '.markdown', '.md', '.mht', '.mhtml', '.mime', '.mjs', '.nws', '.pl', '.py', '.rst', '.s', '.sql', '.srt', '.text', '.txt', '.vcf', '.vtt', '.xml', '.ts', '.tsx', '.jsx', '.java', '.go', '.rs', '.scala', '.kt', '.kts', '.swift', '.lua', '.r', '.jl', '.rb', '.sh', '.bash', '.zsh', '.tex', '.cs', '.php', '.diff', '.patch', '.yaml', '.yml', '.toml', '.graphql', '.gql', '.ndjson', '.json5', '.hcl', '.tf', '.ini', '.properties', '.proto', '.makefile', '.dockerfile', '.cmake', '.gradle', '.sass', '.scss', '.less', '.vue', '.dart', '.ex', '.exs', '.clj', '.groovy', '.awk'];
export var AI_CHAT_MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export var AI_CHAT_MAX_TOTAL_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export var toFileExtension = function toFileExtension(fileName) {
  var normalized = fileName.trim().toLowerCase().split('?')[0];
  var extension = normalized.lastIndexOf('.') >= 0 ? normalized.split('.').pop() : '';
  return extension !== null && extension !== void 0 ? extension : '';
};
export var normalizeAllowedFileExtensions = function normalizeAllowedFileExtensions() {
  var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return extensions.map(function (extension) {
    return extension.replace(/^\./, '').toLowerCase();
  }).filter(Boolean);
};
export var toMegabytes = function toMegabytes(valueInBytes) {
  return valueInBytes / (1024 * 1024);
};
export var isFileExtensionAllowed = function isFileExtensionAllowed(fileName, allowedExtensions) {
  var normalizedExtensions = normalizeAllowedFileExtensions(allowedExtensions);
  return normalizedExtensions.includes(toFileExtension(fileName));
};
export var isFileSizeWithinLimit = function isFileSizeWithinLimit(size, limitMb) {
  return typeof size === 'number' && size >= 0 && (limitMb <= 0 || size <= limitMb * 1024 * 1024);
};
export var isTotalFileSizeWithinLimit = function isTotalFileSizeWithinLimit(sizes, limitMb) {
  return limitMb <= 0 || sizes.reduce(function (total, size) {
    return total + (size !== null && size !== void 0 ? size : 0);
  }, 0) <= limitMb * 1024 * 1024;
};
export var isAiChatSupportedFileName = function isAiChatSupportedFileName(fileName) {
  return AI_CHAT_SUPPORTED_FILE_EXTENSIONS.some(function (extension) {
    return fileName.toLowerCase().endsWith(extension);
  });
};
export var isAiChatFileSizeValid = function isAiChatFileSizeValid(size) {
  return typeof size === 'number' && size >= 0 && size < AI_CHAT_MAX_FILE_SIZE_BYTES;
};